import { Injectable } from '@angular/core';
import { LU_JobCategoryServiceBase } from 'scaletech-jobs';
import { HttpClient } from '@angular/common/http';
import { WebApiService } from 'starbase-login';

@Injectable({
  providedIn: 'root'
})
export class LU_JobCategoryService extends LU_JobCategoryServiceBase {

  constructor(http: HttpClient, webApi: WebApiService) {
    super(http, webApi);
  }
}
